import React from 'react';
import { useTranslation } from 'react-i18next';

import { getRangeValue } from 'component/Layout/Form/RangeSlider/__helper/getRangeValue';

import { Feature } from 'config/features';

import {
    useDepartureFlightTimeAtom,
    useDirectFlightAtom,
    useReturnFlightTimeAtom,
    useWithNoBagAtom,
} from 'hooks/form/filter';
import {
    useChangedFilterList,
    useChangedFilterListForSlider,
} from 'hooks/form/useChangedFilterList';
import { useFeature } from 'hooks/useFeature';
import { QaIdentifier } from 'hooks/useQa';

import Segment from '../Segment';
import { FilterKeys } from '../types';

import { getSelected } from './__helper/getSelected';
import DepartureFlightTime from './__partials/DepartureFlightTime';
import DirectFlight from './__partials/DirectFlight';
import ReturnFlightTime from './__partials/ReturnFlightTime';
import WithNoBag from './__partials/WithNoBag';

export interface FlightTimeProps {
    onSelect: (value: string) => void;
}
const Flight = () => {
    const { t } = useTranslation();
    const isSearchForNoBagActive = useFeature(Feature.SearchForNoBag);
    const [directFlight, setIsDirectFlight] = useDirectFlightAtom();
    const [withNoBag, setWithNoBag] = useWithNoBagAtom();
    const [departureFlightTime, setDepartureFlightTime] =
        useDepartureFlightTimeAtom();
    const [returnFlightTime, setReturnFlightTime] = useReturnFlightTimeAtom();
    const { onClear: onClearCheckboxes } = useChangedFilterList();
    const { onClear: onClearDeparture, onSelect: onSelectDeparture } =
        useChangedFilterListForSlider(FilterKeys.DepartureFlightTime, () =>
            getRangeValue(departureFlightTime)
        );
    const { onClear: onClearReturn, onSelect: onSelectReturn } =
        useChangedFilterListForSlider(FilterKeys.ReturnFlightTime, () =>
            getRangeValue(returnFlightTime)
        );

    const filterList = [
        DirectFlight(),
        WithNoBag(),
        DepartureFlightTime({ onSelect: onSelectDeparture }),
        ReturnFlightTime({ onSelect: onSelectReturn }),
    ];

    if (!isSearchForNoBagActive) {
        filterList.splice(1, 1);
    }

    return (
        <Segment
            withDeleteLink
            onDelete={() => {
                onClearCheckboxes(() => getSelected(directFlight, withNoBag));
                onClearDeparture();
                onClearReturn();
                setIsDirectFlight(false);
                setWithNoBag(false);
                setDepartureFlightTime(undefined);
                setReturnFlightTime(undefined);
            }}
            qaIdentifier={QaIdentifier.Search_Filter_Section_Flight}
            headline={{
                text: t('TRANS-flight'),
            }}
            filterList={filterList}
        />
    );
};

export default Flight;
